import { render } from "./Index.vue?vue&type=template&id=49e402e5&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=49e402e5&lang=scss&scoped=true"

import exportComponent from "/var/www/onlyfoodies-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e402e5"]])

export default __exports__